/* eslint no-mixed-operators: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './style.css';
import { fetchProducts, searchProducts } from '../../actions/product';
import { setScrollDirection, saveScrollTop, saveCurrentDisplayingCatName } from '../../actions/view';
import { isProductsPage, isCategory, isSearchResult } from '../../helpers/urlParts';
import { getProducts } from '../../selectors/product_selector';
var $ = require("jquery");
var throttle = require('lodash.throttle');

const delta = 5;
// const navbarHeight = 64;
const SCROLL_THROTTLING_INTERVAL = 500;
class ScrollView extends Component {
  // constructor(props) {
  //   super(props);
  //   // let didScroll = false;
  //   // let lastViewName = '';
  // }

  shouldComponentUpdate(nextProps) {
    return this.props.products.isInfiniteScroll !== nextProps.products.isInfiniteScroll
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleNavbar);
  }

  componentWillMount() {
    window.addEventListener('scroll', throttle(this.handleScroll, SCROLL_THROTTLING_INTERVAL, { leading: false, trailing: true}));
    window.addEventListener('scroll', throttle(this.handleNavbar, SCROLL_THROTTLING_INTERVAL, { leading: false, trailing: true}));
  }

  handleScroll = (e) => {  
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 1000) {
      this.onReachedTheBottom();
    }
  }

   handleNavbar = (e) => {

      // if (this.props.detailView.isOpen) false;
     //TODO refactor if needed to block more pages
     const path = this.props.router.location.pathname;
     if (isProductsPage(path)) {
       if (!this.props.products.isInfiniteScroll) return;
       const st = $(window).scrollTop();
       this.props.saveScrollTop(st);
       const lastScrollTop = this.props.view.pos;
       // Make sure they scroll more than delta

       if(Math.abs(lastScrollTop - st) <= delta)
         return;
       // If they scrolled down and are past the navbar, add class .nav-up.
       // This is necessary so you never see what is "behind" the navbar.
       if (st > lastScrollTop && st > 138){
         // Scroll Down
         this.props.setScrollDirection('down');
         // $headerWrapper.removeClass('nav-down').addClass('nav-up');
         // $content.removeClass('content-down').addClass('content-up');
       } else {
         // Scroll Up
         if (st + $(window).height() < $(document).height()) {
           this.props.setScrollDirection('up');
           // $headerWrapper.removeClass('nav-up').addClass('nav-down');
           // $content.removeClass('content-up').addClass('content-down');
         }
       }
       this.props.saveScrollTop(st);
     }
    }


  onReachedTheBottom = () => {
    const path = this.props.router.location.pathname;

    if (isSearchResult(path)) {
      this.props.searchProducts();
      
    } else if (isProductsPage(path)) {
      if (!this.props.products.fetching && this.props.products.data.length < this.props.products.totalPages
        || !this.props.products.fetching && this.props.products.currentCategoryIndex <= this.props.config.categories.length-1 && this.props.products.isInfiniteScroll) {
        this.props.fetchProducts();
      }
    }
  }

  render() {
    return (
      <div ref="elem">
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    view : state.view,
    config : state.config,
    products : getProducts(state),
    router: state.router
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
    // setNavBar: (status) => dispatch(setNavBar(status)),
    // setAddressBar: (status) => dispatch(setAddressBar(status)),
    // setCatBar: (status) => dispatch(setCatBar(status)),
    saveCurrentDisplayingCategory: (name) => dispatch(saveCurrentDisplayingCatName(name)),
    saveScrollTop: (pos) => dispatch(saveScrollTop(pos)),
    setScrollDirection: (direction) => dispatch(setScrollDirection(direction)),
    fetchProducts: () => dispatch(fetchProducts()),
    searchProducts: () => dispatch(searchProducts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollView);



// WEBPACK FOOTER //
// ./src/components/ScrollView/ScrollView.jsx